module.exports = __webpack_public_path__ + "img/forestorytellingtour_main_07.c88223b0.jpg";